import { Typography } from 'atoms/Typography'
import { themeFromStore } from 'core/helpers/menu'
import translate from 'core/translate'
import { isNotEmptyArray } from 'core/utils/coreUtil'
import React, { FC } from 'react'
import { styles } from './PlatformCard-styles'
import { PlatformCardProps } from './PlatformCard-types'
import { PlatformCardTable } from './PlatformCardTable'
import helpers from 'core/helpers'
import { useLocation } from 'react-router'
import AnimationWrapper from 'blocks.app/animationWrapper/animationWrapper'

export const PlatformCard: FC<PlatformCardProps> = ({ platform, selectedItems, onDelete, onSelect, filter }) => {
    const { title, description, installationLink, displayedClientAppType, lastClientApplications, type } = platform
    const prepareType = (type: string) => type.toLowerCase().split(' ').join('')

    const getIcon = () => {
        return (
            <div
                className={styles.platform__logo}
                style={{
                    opacity:
                        type.includes('REDOS') ||
                        type.includes('IMAQLIQ') ||
                        type.includes('E-PAPER') ||
                        type.includes('ANDROID 4')
                            ? 0
                            : 1,
                }}
            >
                <img src={`images/distributives/platforms/${prepareType(type.replace(/\//g, ''))}.png`} />
            </div>
        )
    }

    const getDistributives = () => {
        return lastClientApplications.filter((item) => {
            if (filter === 'ofUsers') {
                return item.uploadedBy
            }
            if (filter === 'general') {
                return !item.uploadedBy
            }

            return true
        })
    }

    const renderTable = () => {
        return (
            <AnimationWrapper>
                <div className={styles.platform__body}>
                    <div className={styles.platform__table}>
                        <PlatformCardTable
                            distributives={getDistributives()}
                            displayedClientAppType={displayedClientAppType}
                            type={type}
                            selectedItems={selectedItems}
                            onSelect={onSelect}
                            onDelete={onDelete}
                            simpleLink={helpers.isAvailable({
                                key: 'distributiveShowDirectLinkSettings',
                                action: 'read',
                            })}
                        />
                    </div>
                </div>
            </AnimationWrapper>
        )
    }

    const location = useLocation()
    const pathname = helpers.getPathname(location.pathname)

    return (
        <div
            className={
                themeFromStore() === 'custom' && pathname === 'distributive'
                    ? styles.platform_custom_theme
                    : styles.platform
            }
        >
            <div className={styles.platform__header}>
                <div className={styles.platform__info}>
                    {getIcon()}
                    <div className={styles.platform__content}>
                        <Typography className={styles.platform__title} type="title">
                            {title}
                        </Typography>
                        <Typography className={styles.platform__description} type="title">
                            {description}
                        </Typography>
                    </div>
                </div>
                <div className={styles.platform__link}>
                    <Typography type="title">
                        <a href={installationLink} target="_blank">
                            {translate('distributiveInstallationGuide')}
                        </a>
                    </Typography>
                </div>
            </div>
            {isNotEmptyArray(lastClientApplications) && renderTable()}
        </div>
    )
}
